import { neutral } from "decentraland-ui2/dist/theme/colors"

import { Box, Button, Typography, styled, useTheme } from "decentraland-ui2"

const DownloadDetail = styled(Box)(() => {
  const theme = useTheme()
  return {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    border: "none",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      alignItems: "center",
      marginTop: "48px",
    },
  }
})

const DownloadImageContainer = styled(Box)(() => {
  const theme = useTheme()

  return {
    maxWidth: "900px",
    width: "50%",
    height: "100%",
    overflow: "hidden",
    borderRadius: "24px",
    border: "none",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  }
})

const DownloadImage = styled("img", {
  shouldForwardProp: (prop) => prop !== "objectFit",
})((props: { objectFit?: "cover" | "contain" }) => ({
  width: "100%",
  height: "100%",
  objectFit: props.objectFit || "cover",
}))

const DclWhiteLogo = styled("img")({
  height: "48px",
  width: "48px",
})

const DownloadTitle = styled(Typography)(() => {
  const theme = useTheme()
  return {
    marginTop: "8px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: "3rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.8rem",
    },
  }
})

const DownloadSubtitle = styled(Typography)(() => {
  const theme = useTheme()
  return {
    marginTop: "8px",
    marginBottom: "16px",
    color: neutral.gray4,
    "& span": {
      fontWeight: 700,
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  }
})

const DownloadUnavailable = styled(Box)(() => {
  const theme = useTheme()
  return {
    marginTop: "8px",
    width: "460px",
    [theme.breakpoints.down("xl")]: {
      width: "390px",
    },
    [theme.breakpoints.down("lg")]: {
      width: "320px",
    },
  }
})

const DownloadUnavailableIFrame = styled("iframe")({
  width: "100%",
  border: "none",
})

const DownloadActions = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginTop: "24px",
})

const DowloadButtonsContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  "@media (max-width: 1830px)": {
    flexDirection: "column",
    alignItems: "flex-start",
  },
})

const DownloadButtonImage = styled("img")({
  height: "32px",
  width: "32px",
  filter: "brightness(0) invert(1)",
})

const DownloadAlternativeContainer = styled(Box)(() => {
  const theme = useTheme()
  return {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginTop: "16px",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  }
})

const DownloadAlternativeTitle = styled(Typography)({
  "&.MuiTypography-root.MuiTypography-body1": {
    marginTop: "8px",
    marginRight: "8px",
  },
})

const DownloadAlternativeButtonsWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
})

const DownloadAlternativeButton = styled(Button)({
  display: "flex",
  alignItems: "center",
  "& span.MuiButton-icon.MuiButton-startIcon.MuiButton-iconSizeMedium": {
    marginRight: 0,
    marginLeft: 0,
  },
})

const DownloadAlternativeButtonImage = styled("img")({
  height: "24px",
  width: "24px",
  filter: "brightness(0) invert(1)",
})

export {
  DownloadDetail,
  DownloadImageContainer,
  DownloadImage,
  DclWhiteLogo,
  DownloadTitle,
  DownloadSubtitle,
  DownloadUnavailable,
  DownloadUnavailableIFrame,
  DownloadActions,
  DowloadButtonsContainer,
  DownloadButtonImage,
  DownloadAlternativeContainer,
  DownloadAlternativeTitle,
  DownloadAlternativeButtonsWrapper,
  DownloadAlternativeButton,
  DownloadAlternativeButtonImage,
}
